import { render, staticRenderFns } from "./Standorte.vue?vue&type=template&id=0248c901&"
import script from "./Standorte.vue?vue&type=script&lang=js&"
export * from "./Standorte.vue?vue&type=script&lang=js&"
import style0 from "./Standorte.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports